import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface Benefit {
  icon: string;
  title: string;
  description: string;
  gradient: string;
}

@Component({
  selector: 'app-business-benefits',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './business-benefits.html',
  styleUrl: './business-benefits.css',
})
export class BusinessBenefitsComponent {
  readonly benefits: Benefit[] = [
    {
      icon: 'fas fa-diagram-project',
      title: 'One dashboard, every branch',
      description: 'See sales, stock, and staff across every outlet in real time, no more chasing spreadsheets between locations.',
      gradient: 'linear-gradient(135deg, #009ebf 0%, #3758a7 100%)',
    },
    {
      icon: 'fas fa-bolt',
      title: 'Live in days, not months',
      description: 'Retail, healthcare, education, and manufacturing modules come pre-built, so you are running on day one.',
      gradient: 'linear-gradient(135deg, #f2994a 0%, #eb5c6f 100%)',
    },
    {
      icon: 'fas fa-arrow-trend-up',
      title: 'Scale without switching systems',
      description: 'Add branches, users, or modules whenever you grow, your data and workflows carry over automatically.',
      gradient: 'linear-gradient(135deg, #8a63d2 0%, #2fb380 100%)',
    },
  ];
}
